import React from 'react';
import { Lightbulb } from 'lucide-react';

interface RecommendationCardProps {
  title: string;
  description: string;
}

const RecommendationCard: React.FC<RecommendationCardProps> = ({ title, description }) => {
  return (
    <div className="border rounded-lg p-5 bg-gray-50">
      <div className="flex items-start">
        <Lightbulb className="text-yellow-500 mr-3 flex-shrink-0 mt-1" size={20} />
        <div>
          <h3 className="font-semibold text-gray-800 mb-2">{title}</h3>
          <p className="text-gray-600">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default RecommendationCard;